import ControlTowerCreation, {
  useControlTowerCreation,
} from 'v3/components/ControlTowerCard/Creation';
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import ApplicationLayout from 'v3/layouts/Application';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import { usePermission } from 'hooks';
import Section from '../shared/Section';
import DataInputs from '../shared/Data/Inputs';
import MainInputs from '../shared/Main/Inputs';
import OwnerInputs from '../shared/Owner/Inputs';
import ImplementsInputs from '../shared/Implements/Inputs';
import Drivers from '../shared/Drivers';
import TollTags from './TollTags';
import { useVehicle } from '../shared/context';

import { handleCreation } from './controller';

export default function VehicleRegister() {
  const navigate = useNavigate();
  const vehicle = useVehicle();
  const control = useControlTowerCreation('vehicle');

  usePermission('CADASTRAR_VEICULOS', { redirect: true });

  const [isLoading, setLoading] = useState(false);

  return (
    <ApplicationLayout
      title="Cadastrar veículo"
      RightComponent={
        <>
          <Button variant="secondary" onClick={() => navigate('/veiculos')}>
            <Text weight={500} color="black" type="regular">
              Voltar
            </Text>
          </Button>

          <Button
            variant="success"
            onClick={async () => {
              const id = await control.submit(() =>
                handleCreation(
                  vehicle.data,
                  vehicle.setData,
                  vehicle.setErrors,
                  vehicle.showSnackbar,
                  setLoading,
                  true,
                ),
              );
              if (id) {
                vehicle.setData({ id });
                vehicle.showSnackbar('Veículo e disponibilidade salvos.', { type: 'success' });
              }
            }}
            loading={isLoading || control.busy}
          >
            <Text weight={500} color="white" type="regular">
              Salvar veículo
            </Text>
          </Button>
        </>
      }
    >
      <fieldset
        inert={!!control.createdId}
        disabled={isLoading || control.busy || !!control.createdId}
        style={{ border: 0, padding: 0 }}
      >
        <Row>
          <Col xs={12} md={6}>
            <Section Title="Veículo tração">
              <MainInputs />
            </Section>
            <Drivers />
            <TollTags />
          </Col>
          <Col xs={12} md={6}>
            <Section Title="Implementos">
              <ImplementsInputs />
            </Section>
            <Section Title="Conjunto">
              <DataInputs />
            </Section>
            <Section Title="Proprietário">
              <OwnerInputs />
            </Section>
          </Col>
        </Row>
      </fieldset>
      <ControlTowerCreation control={control} />
    </ApplicationLayout>
  );
}
